export let LogoType = /*#__PURE__*/function (LogoType) {
  LogoType["custom"] = "custom";
  LogoType["siteLogo"] = "siteLogo";
  LogoType["wixStudio"] = "wixStudio";
  LogoType["wixClassic"] = "wixClassic";
  LogoType["wixPayments"] = "wixPayments";
  LogoType["wixVibe"] = "wixVibe";
  LogoType["marketplace"] = "marketplace";
  LogoType["rise"] = "rise";
  LogoType["wixel"] = "wixel";
  LogoType["quickbooksAndClassic"] = "quickbooksAndClassic";
  LogoType["quickbooksAndStudio"] = "quickbooksAndStudio";
  return LogoType;
}({});
//# sourceMappingURL=types.js.map